module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/30-0c05822df0aea698d835346a9d7ba886.jpg";